import { useEffect, useState } from "react";

export default function useCountdown(targetDateUTC) {
  // Ensure UTC timestamp
  const targetTime = new Date(targetDateUTC).getTime();

  const [countDown, setCountDown] = useState(
    targetTime - Date.now()
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(targetTime - Date.now());
    }, 1000);

    return () => clearInterval(interval);
  }, [targetTime]);

  const totalSeconds = Math.max(0, Math.floor(countDown / 1000));

  return {
    days: Math.floor(totalSeconds / (60 * 60 * 24)),
    hours: Math.floor((totalSeconds / (60 * 60)) % 24),
    minutes: Math.floor((totalSeconds / 60) % 60),
    seconds: Math.floor(totalSeconds % 60),
    expired: countDown <= 0
  };
}
